export const DEFAULT_GROUP_LIST_SIZE = 5;

export const createAddClassName = (name: string) => {
  return "t--datasoucre-create-option-" + name.toLowerCase().replace(/ /g, "_");
};

export const LAST_VISITED_MODULE_KEY = "APPSMITH_LAST_VISITED_UI_MODULE_KEY";
